<template>
  <button
    class="line-button"
    :class="[`style-${item.style || 'link'}`, `height-${item.height || 'md'}`]"
    :style="customStyle"
  >
    {{ item.action?.label }}
  </button>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  item: Object
})

const customStyle = computed(() => {
  const color = props.item.color
  if (!color) return {}

  return props.item.style === 'link'
    ? { color }
    : { backgroundColor: color, borderColor: color }
})
</script>

<style scoped>
.line-button {
  width: 100%;
  box-sizing: border-box;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.line-button:active {
  opacity: 0.6;
}

.height-sm { padding: 6px 8px; }
.height-md { padding: 11px 8px; }

/* primary: 塗りつぶし（LINEグリーン） */
.style-primary {
  background-color: #06c755;
  border: none;
  color: #ffffff;
}

/* secondary: グレー背景 */
.style-secondary {
  background-color: #f2f3f5;
  border: none;
  color: #111111;
}

/* link: テキストのみ（LINEのリンク色） */
.style-link {
  background-color: transparent;
  border: none;
  color: #469fd6;
}
</style>
